module.exports = __webpack_public_path__ + "static/media/transition.be9480f6.jpg";